import { computed } from "vue";
import { u as useComponentUuid } from "../../../composables/useComponentUuid.js";
const useMessageListAria = (props) => {
  const id = useComponentUuid();
  const messageListId = `message-list-${id}`;
  const messageListAttributes = computed(() => ({
    id: messageListId,
    role: "alert"
  }));
  const doHaveMessages = computed(() => {
    if (typeof props.modelValue === "string" && props.modelValue.length > 0) {
      return true;
    }
    if (Array.isArray(props.modelValue) && props.modelValue.length > 0) {
      return true;
    }
    return false;
  });
  const childAttributes = computed(() => ({
    "aria-describedby": doHaveMessages.value ? messageListId : void 0,
    "aria-invalid": props.hasError
  }));
  return {
    messageListAttributes,
    childAttributes
  };
};
export {
  useMessageListAria as u
};
//# sourceMappingURL=useMessageListAria.js.map
